<template>
    <div>
        <div class="panel">
            <div class="panel-heading">
                <div class="panel-label color-black">
                    <h3>{{$t('PROMOTIONS.title')}}</h3>
                </div>
                <div class="panel-toolbar color-black" v-if="edit && $isAllowed('edit')">
                    <cph-button @clicked="isFormOpen = true"
                                :buttonText="'Manage promotions'"
                                :classList="'btn btn-cph-primary'">
                    </cph-button>
                </div>
            </div>
            <div class="panel-body">
                <div class="row" slot="body">
                    <div class="col-12">
                        <!--ACTIVE PROMOTIONS HERE-->
                        <active-regular-promotions :promotions="regularPromotions"
                                                    @product="openForm($event)" :symbol="symbol" :edit="true" :bulk="true"
                                                    @bulkActivatePromotion="promotionUpdate"
                                                @bulkRemovePromotion="promotionRemove"
                            @addFunctionToSave="addFunctionToSave" @saveFunctions="saveFunctions"/>
                    </div>

                    <div class="col-12">
                        <!--BULK PRICE LIST-->
                        <active-bulk-promotions :promotions="bulkPromotions"
                                                @product="openForm($event)" :symbol="symbol" :edit="true" :bulk="true"
                                                @bulkActivatePromotion="promotionUpdate"
                                                @bulkRemovePromotion="promotionRemove"
                            @addFunctionToSave="addFunctionToSave" @saveFunctions="saveFunctions"/>
                    </div>
                </div>

                <div class="row" slot="body">
                    <div class="col-12">
                        <h2>{{$t('COMMON.history')}}</h2>
                    </div>
                    <div class="col-12">
                        <active-regular-promotions :promotions="historyOfRegularPromotions" :edit="true" :bulk="true"
                                                    @product="openForm($event)" :symbol="symbol" :history="true"
                                                    @bulkActivatePromotion="promotionUpdate"
                                                    @bulkRemovePromotion="promotionRemove"
                            @addFunctionToSave="addFunctionToSave" @saveFunctions="saveFunctions"/>
                    </div>
                </div>
            </div>
        </div>

        <transition name="fade" mode="out-in" v-if="$isAllowed('edit')">
            <functional-modal
                @close="closeForm"
                @save="saveButton"
                key="promotion-modal"
                :showModal="isFormOpen"
                :showSave="true"
                :big="true"
                :title="formTitle"
                closeText="UI.cancel"
                v-if="isFormOpen"
            >
                <div :class="['col-12 color-black']" slot="body">
                    <promotion-form-bulk
                        :products="products"
                        :editedProduct="currentProduct"
                        :prices="prices"
                        @addFunctionToSave="addFunctionToSave"
                        :showadd="showadd"
                        @updatepromotion="promotionUpdate"
                        @removePromotion="promotionRemove"
                        @addPromotion="promotionAdd"
                        :promotions="promotions"
                        :symbol="symbol"
                        @saveFunctions="saveFunctions"
                    />
                </div>
            </functional-modal>
        </transition>
    </div>
</template>

<script type="text/babel">
import {mapGetters, mapMutations, mapActions} from 'vuex';

import Filters from '../../../mixins/CphFilters.vue';
import CphWidget from '../../../components/Shared/CphWidget.vue';
import {PromotionsPerimeter} from '../../../router/perimeters/promotionsPerimeter';
import ActiveRegularPromotions from '../../../components/Panel/Promotions/ActiveRegularPromotions';
import ActiveBulkPromotions from '../../../components/Panel/Promotions/ActiveBulkPromotions';
import CphButton from '../../../components/Shared/UI/Button/CphButton';
import FunctionalModal from '../../../components/Shared/Modal/FunctionalModal.vue';
import PromotionFormBulk from '../../../components/Panel/Promotions/PromotionFormBulk';
import PromotionMixin from '../../../components/Panel/Promotions/PromotionMixin';
import FeeTable from '../Fee/FeeTable.vue';

export default {
    name: 'PromotionsViewBulk',
    props:{
        edit:{
            type: Boolean,
            default: false
        },
        formOpen: {
            type: Boolean,
            default: false,
        },
        selectedProduct: {
            type: Object,
            default: null
        },
        orderFee: {
            type: Object,
            default: null,
        },
        showadd: {
            type: Boolean,
            default: true,
        }
    },
    data(){
        return {
            isFormOpen: this.formOpen,
            currentProduct: this.selectedProduct,
            funcStack: {},
            symbol: 'EUR',
            promotionsAdded: [],
            promotions: [],
            promotionsToSave: [],
        }
    },
    watch: {
        formOpen(newVal, oldVal){
            this.isFormOpen = newVal;
        },
        selectedProduct(newVal, oldVal) {
            this.currentProduct = newVal;
        },
    },
    perimeters: [PromotionsPerimeter],
    mixins: [Filters, PromotionMixin],
    computed: {
        ...mapGetters({
            products: 'getProducts',
            prices: 'getAllPrices',
            // promotions: 'getPromotions',
            getProductsById: 'getProductsById',
            getFees: 'getFees',
            getActiveShop: 'getActiveShop',
        }),
        formTitle () {
            return this.$t('PROMOTIONS.manage');
        },
        activeOrUpcomingPromotions () {
            return this.promotions.filter(promotion => !this.hasFinished(promotion));
        },
        finishedPromotions () {
            return this.promotions.filter(promotion => this.hasFinished(promotion));
        },
        bulkPromotions () {
            return this.activeOrUpcomingPromotions.filter(({type}) => type === 'bulk');
        },
        regularPromotions () {
            return this.activeOrUpcomingPromotions.filter(({type}) => type === 'period');
        },
        historyOfRegularPromotions () {
            return this.finishedPromotions.filter(({type}) => type === 'period');
        }
    },
    methods: {
        ...mapActions([
            'productsSaved',
            'GetShopById'
        ]),
        ...mapGetters([ 'currentShop']),
        feeTableClicked (data) {
            if(this.$route.name === 'FastEdit') {
                this.$emit('feeTableClicked', data)
            }
        },
        async openForm (product) {
            if(this.$route.name === 'FastEdit') { // work only in fastedit page
                if (this.$isNotAllowed('edit')) {
                    return;
                }
                let productById = await this.getProductsById(product)[0];
                this.isFormOpen = true;
                this.currentProduct = productById;
            }
        },
        async closeForm () {
            this.isFormOpen = false;
            this.$emit('closeModal');
        },
        addFunctionToSave(func) {
            this.funcStack[func.id] = func.run;
        },
        saveFunctions (){
            Object.values(this.funcStack).forEach(async (fnc) => {
                try {
                    await fnc();
                } catch (error) {
                    throw error;
                }
            })
            this.funcStack = {}
            return Promise.resolve()
        },
        saveButton(){
            this.promotions = [...this.promotions, ...this.promotionsToSave, ];
            this.promotionsToSave = [];
            Promise.resolve()
            .then(() => {
                this.$emit("promotions", this.promotions)
                this.closeForm()
            })
            .catch(err => {
                this.closeForm()
            })
        },
        promotionAdd(promotion){
            if((promotion.price > 0 && promotion.quantity > 0) || (promotion.price > 0 && promotion.endTime && promotion.startTime))
                this.promotionsToSave.push(promotion)
        },
        promotionUpdate(promotion){
            this.promotionsToSave.splice( this.promotionsToSave.findIndex(p => p.id == promotion.id), 1)
            this.promotionsToSave.push(promotion)
        },
        promotionRemove(id){
            this.promotionsToSave.splice( this.promotionsToSave.findIndex(p => p.id == id), 1)
            this.promotions.splice( this.promotionsToSave.findIndex(p => p.id == id), 1)
        },
    },
    components: {
        PromotionFormBulk,
        ActiveBulkPromotions,
        ActiveRegularPromotions,
        CphWidget,
        CphButton,
        FunctionalModal,
        FeeTable
    }
};

</script>

<style lang="scss">

    .color-black {
        color: black;
    }
</style>
